/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import SystemNotificationAPI from '@/api/SystemNotificationAPI.js';

export default {
	getNotiByMisaId: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SystemNotificationAPI.getAPIUrl() + '/getnotibymisaid',
				param: payload
			},
			false
		);

		if (res.Success) {
			context.commit('updateNoti', res);
		}

		// Trả kết quả
		return res;
	},

	insertUserNotiNotView: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SystemNotificationAPI.getAPIUrl() + '/insertusernoti',
			data: payload
		});

		// Trả kết quả
		return res;
	},

	updateReadUserNoti: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SystemNotificationAPI.getAPIUrl() + '/updatereadusernoti',
			data: payload
		});

		// Trả kết quả
		return res;
	}
};
